import { Component } from 'react'
import { withTranslation } from '~/i18n'
import types from '~/types/ordersPage.ts'
import DropdownMenu from '../../components/DropdownMenu'
import styles from '~/styles/ordersPageExportTo.module.css'

class ExportTo extends Component<types.exportTo_props, types.exportTo_state> {
	private _timeout: NodeJS.Timeout

	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}
	
	constructor(props: types.exportTo_props) {
		super(props)
		this.state = {
			title: null,
			titleOnly: false,
		}
	}
	
	render(): JSX.Element {
		return (
			<DropdownMenu
				title={this.state.title || this.props.t('Export to')}
				titleOnly={this.state.titleOnly}
				setClickedComponent={this.props.setClickedComponent}
				isOuterClicked={this.props.isOuterClicked}
			>
				{this._button("XLSX")}
				{this._button("CSV")}
			</DropdownMenu>
		)
	}
	
	private _button(exportType: string): JSX.Element {
		return (
			<div
				className={styles.button}
				onClick={this._onClick.bind(this, exportType)}
			>
				{exportType}
			</div>
		)
	}
	
	private _onClick(exportType, aa): void {
		this.setState({
			titleOnly: true,
			title: this.props.t('Orders:Exporting to') + ' ' + exportType
		})
		if (this._timeout) {
			clearTimeout(this._timeout)
		}
		this._timeout = setTimeout(() => {
			this.setState({
				titleOnly: false,
				title: this.props.t('Export to'),
			})
		}, 1000 * 30)
		const headers: types.exportTo_headers = {
			'Content-Type': 'application/json',
			locale: this.props.locale,
			access_token: this.props.access_token,
			access_realm: this.props.access_realm,
		}
		const browserTimezoneOffset = new Date().getTimezoneOffset() * -1
		const browserTimezone = browserTimezoneOffset / 60
		const postObject: types.exportTo_postObject = {
			dealerId: this.props.dealerId,
			startDate: this.props.dates?.['startDate'] || '',
			endDate: this.props.dates?.['endDate'] || '',
			orderStatus: this.props?.orderStatus || '',
			searchFilter: this.props?.searchFilter || '',
			showedColumns: this.props?.showedColumns,
			exportType,
			browserTimezone,
			chartDate: this.props.chartDate,
			chartStatus: this.props.chartStatus,
			cityOrRegion: this.props.chartCityOrRegion,
			isRegion: this.props.chartIsRegion,
			chartNpsType: this.props.chartNpsType,
			chartBopa: this.props.chartBopa,
			chartDayStratification: this.props.chartDayStratification,
			chartDeliveryReturnType: this.props.chartDeliveryReturnType,
			showHierarchy: this.props.showHierarchy,
			timezoneCode: this.props.timezoneCode,
			datePickerColumn: this.props.datePickerColumn,
			chartEndDate: this.props.chartEndDate,
			chartIntervalType: this.props.chartIntervalType,
			chartNpsPerIntervalType: this.props.chartNpsPerIntervalType,
			carrierFilter: this.props.carrierFilter,
		}
		this.props.onAction.send({
        action: 'Export request',
        actionData: {
          file: 'components/OrdersPage/ExportTo.tsx',
          requestUrl: '/api/v1/orders-export-to',
          requestData: postObject,
        },
    })
		fetch('/api/v1/orders-export-to', {
			headers,
			method: 'POST',
			body: JSON.stringify(postObject),
		}).then(async response => {
			if (response.status === 200) {
				return response.blob()
			} else {
				const json = await response.json()
				if (json?.error === 'Access forbidden') {
					this.props.router.push('/login')					
				}
			}
		}).then(blob => {
			if (blob) {
				const file = window.URL.createObjectURL(blob)
				const localUnixDate = Date.now() - new Date().getTimezoneOffset() * 60 * 1000
				let localDate = new Date(localUnixDate).toISOString()
					localDate = localDate.replace(/T/, '_').replace(/Z/, '').replace(/:/g, '-').substring(0, 19)
				const dealerName = (this.props.dealerName + '').replace(/[^a-z0-9]/gi, '_')
				let fileName = `Orders_${dealerName}_${localDate}`
				if (this.props.chartDate) {
					fileName += '__by_chart_date_' + this.props.chartDate
					if (this.props.chartDate) {
						fileName += '_and_status_' + (this.props.chartStatus + '').replace(/[^a-z0-9]/gi, '_')
					}
				}
				fileName += '.' + exportType.toLowerCase()
				let link = document.createElement('a')
					link.setAttribute('href', file)
					link.setAttribute('download', fileName.replace(/[_]+/, '_'))
					link.click()
				clearTimeout(this._timeout)
				this.setState({
					titleOnly: false,
					title: this.props.t('Export to'),
				})
			}
		}).catch(error => {})
	}
}

export default withTranslation(['Orders'])(ExportTo)